module.exports = __webpack_public_path__ + "static/media/edsider4.b58a3182.svg";